import React, {useEffect, useState} from 'react';
import {emptyISearchFilterRequest, IPostSearchResultItem, SearchRepository2, TAB_SEARCH_GET_SIZE} from "repositories/SearchRepository2";
import {getHighlightedTextFromHtml} from "util/commonUtils";
import {SsqImages} from "images/SsqImages";
import {LanguageService} from "language/LanguageService";
import {DocType, getDocTypeLangKey} from "definitions/DocType";
import parse from 'html-react-parser';
import {DocDivisionType} from "definitions/DocDivisionType";
import {ViewmoreArea} from "style/CommonStyledComponents";
import TagManager from "react-gtm-module";
import {ICategory} from "repositories/category/CategoryRepository";
import {useSelector} from "react-redux";
import {IfLoginInfo} from "models/IfLoginInfo";
import {roleutil} from "util/roleutil";
import {DOC_TYPE} from "search2/filter/SearchFilter";
import {loginutil} from "util/loginutil";

interface Props {
  searchRepository: SearchRepository2;
  getTranslatedText: Function;
  languageService: LanguageService;
  searchInput: string;
  setCount: Function;
  isDisplayNextPageButton: boolean;
  srchParam: ISrchParam;
  postInitCount: number;
  setDocument: Function,
}

interface ISrchParam {
  resultType: string;
  sortType: string;
  prodType: ICategory;
  periodType: string;
  tagType: [],
  docType: string,
  rangeType: string,
}


export const PostSearchResultTab = (props: Props) => {
  const [searchPage, setSearchPage] = useState<number>(1);
  const [searchPageResult, setSearchPageResult] = useState<IPostSearchResultItem[]>([]);
  const [postCount, setPostCount] = useState(props.postInitCount);
  const loginInfo = useSelector((state: any): IfLoginInfo => state.main.loginInfo);

  const [isPartners, setIsPartners] = useState<boolean | null>(null);

  useEffect(() => {
    if (loginutil.isnotlogin(loginInfo)) {
      return;
    }

    roleutil.hasPartnerChecks(loginInfo.userId, props.languageService.getLanguage())
      .then((res) => {
        setIsPartners(res);
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsPartners(false);
      });
  }, [loginInfo.userId, props.languageService]); // 필요한 의존성 추가


  useEffect(() => {
    if (searchPage !== 0) {
      props.searchRepository.getPostSearchData({
          ...emptyISearchFilterRequest,
          resultType: props.srchParam.resultType,
          searchKeyword: props.searchInput,
          lang: props.languageService.getLanguage(),
          page: searchPage,
          loginType: loginInfo.loginType,
          size: TAB_SEARCH_GET_SIZE,
          daterange: props.srchParam.periodType,
          category: props.srchParam.prodType,
          orderby: props.srchParam.sortType,
          doctype: props.srchParam.docType,
          rangetype: props.srchParam.rangeType,
          tags: props.srchParam.tagType,
          isPartner: isPartners,
          isRnd: roleutil.hasRole('RND', loginInfo.userRoles)
        }
      ).then(result => {
        setSearchPageResult([...searchPageResult, ...result.items]);
        setPostCount(result.totalCount);
        setSearchPage(searchPage);
      });
    }
  }, [searchPage, isPartners]);

  useEffect(() => {
    if (isPartners !== null || loginutil.isnotlogin(loginInfo)) {
      props.searchRepository.getPostSearchData({
          ...emptyISearchFilterRequest,
          resultType: props.srchParam.resultType,
          searchKeyword: props.searchInput,
          lang: props.languageService.getLanguage(),
          page: 1,
          loginType: loginInfo.loginType,
          size: TAB_SEARCH_GET_SIZE,
          daterange: props.srchParam.periodType,
          category: props.srchParam.prodType,
          orderby: props.srchParam.sortType,
          doctype: props.srchParam.docType,
          rangetype: props.srchParam.rangeType,
          tags: props.srchParam.tagType,
          isPartner: isPartners,
          isRnd: roleutil.hasRole('RND', loginInfo.userRoles)
        }
      ).then(result => {
        setSearchPageResult(result.items);
        setPostCount(result.totalCount);
        setSearchPage(1);
      }).finally(() => {
        props.setDocument('document', true);
      });
    }
  }, [props.searchInput, props.srchParam, loginInfo, isPartners]);

  useEffect(() => {
    props.setCount('post', postCount);
  }, [postCount]);

  function openNewTabForDocument(docType: string, documentId: number) {
    let docDivisionType = getDocDivisionByDocType(docType);

    if (docDivisionType === DocDivisionType.DOWNLOAD || docDivisionType === DocDivisionType.EDUCATION_ARTICLE) {
      window.open(`/product/document/` + documentId, "_blank");
    } else if (docDivisionType === DocDivisionType.TECHNICAL_ARTICLE) {
      window.open(`/solution/document/` + documentId, "_blank");
    } else if (docDivisionType === DocDivisionType.QNA) {
      window.open(`/community/qna/document/` + documentId, "_blank");
    } else if (docDivisionType === DocDivisionType.BLOG) {
      window.open(`/community/blog/document/` + documentId, "_blank");
    } else if (docDivisionType === DocDivisionType.BOARD) {
      window.open(`/community/board/document/` + documentId, "_blank");
    } else if (docDivisionType === DocDivisionType.SAMPLE) {
      window.open(`/service/sample/document/` + documentId, "_blank");
    } else if (docDivisionType === DocDivisionType.RND_NOTI) {
      window.open(`/community/rnd/notice/document/` + documentId, "_blank");
    } else if (docDivisionType === DocDivisionType.RND_TALK) {
      window.open(`/community/rnd/talk/document/` + documentId, "_blank");
    } else if (docDivisionType === DocDivisionType.RND_QNA) {
      window.open(`/community/rnd/qna/document/` + documentId, "_blank");
    } else if (docDivisionType === DocDivisionType.SW_SERVICE) {
      window.open(`/service/software/document/` + documentId, "_blank");
    } else {
      console.log(docType, documentId);
      // TODO 유효하지 않은 URL 문구 화면
    }
  }

  function getDocDivisionByDocType(docType: string): string {
    let docDivisionType = "";

    if (docType === DocType.MANUAL || docType === DocType.CATALOG || docType === DocType.CERTIFICATION
      || docType === DocType.CAD_DATA || docType === DocType.DATASHEET || docType === DocType.SOFTWARE
      || docType === DocType.OS || docType == DocType.TROUBLE_SHOOTING) {
      docDivisionType = DocDivisionType.DOWNLOAD;
    } else if (docType === DocType.EDUCATION_VIDEO || docType === DocType.EDUCATION_NOTE) {
      docDivisionType = DocDivisionType.EDUCATION_ARTICLE;
    } else if (docType === DocType.APPLICATION_NOTE || docType === DocType.TECH_GENERAL || docType === DocType.TECHNICAL_GUIDE) {
      docDivisionType = DocDivisionType.BLOG;
    } else if (docType === DocType.QNA_Q || docType === DocType.QNA_A) {
      docDivisionType = DocDivisionType.QNA;
    } else if (docType === DocType.TIP || docType === DocType.DOC_EVT || docType === DocType.DOC_NOTI || docType === DocType.JOB_SEARCH || docType === DocType.JOB_OFFER) {
      docDivisionType = DocDivisionType.BOARD;
    } else if (docType === DocType.USER_SAMPLE || docType === DocType.SAMPLE) {
      docDivisionType = DocDivisionType.SAMPLE;
    } else if (docType === DocType.RND_NOTI) {
      return DocDivisionType.RND_NOTI;
    } else if (docType === DocType.RND_TALK) {
      return DocDivisionType.RND_TALK;
    } else if (docType === DocType.RND_QNA_Q || docType === DocType.RND_QNA_A) {
      return DocDivisionType.RND_QNA;
    } else if (docType === DocType.SW_SERVICE) {
      return DocDivisionType.SW_SERVICE;
    }
    return docDivisionType;
  }

  function getPageCount() {
    return (20 * (searchPage));
  }

  function getTotalCount() {
    return postCount;
  }

  return <div className={"page-area"}>
    <div className={"result-title"}>{props.getTranslatedText("I18N_ALL_SEARCH_TAB_POST")}
      <span>{postCount}</span>
    </div>
    {searchPageResult.map((item, index) => {
      if (!props.isDisplayNextPageButton && index >= 5) return;
      const convertTag = item.tag.replace(/(<b class='search_highlight'>[^<]*<\/b>)|\s+/g, (match, highlightTag) => {
        return highlightTag ? highlightTag : '&nbsp;&nbsp;#';
      });
      return <div key={index} className={"result-item"}>
        <div onClick={() => {
          TagManager.dataLayer({
            dataLayer: {
              "event": "search_click",
              "click_search_keyword": props.searchInput,
              "click_title": item.doc_title
            }
          });
        }}>
          <div className={"result-item-tit"}>
            <div className={"page-name tit"}>
              <span onClick={() =>
                openNewTabForDocument(item.doc_type, ["QNA_A", "RND_QNA_A"].includes(item.doc_type) ? item.question_id : item.id)
              }>
                  {parse(getHighlightedTextFromHtml(item.doc_title))}
              </span>
              {item.display_target === '20' &&
                <div><p className={"level"}>{props.getTranslatedText("I18N_ALL_SEARCH_EMPLOYEE_ONLY")}</p>
                </div>}

              {item.display_target === '15' &&
                <div><p className={"partner"}>{props.getTranslatedText("I18N_ALL_SEARCH_PARTNER")}</p>
                </div>}

              {["RND_NOTI", "RND_TALK", "RND_QNA_Q", "RND_QNA_A"].includes(item.doc_type) &&
                <div><p className={"level"}>{props.getTranslatedText("I18N_ALL_SEARCH_RND")}</p>
                </div>}
            </div>
          </div>
          <div className={"result-item-info " + (item.image_url && "result-item-img-info")}>
            {item.image_url &&
              <div className={"img-wrap " + (item.image_url ? "img" : "none")}>
                <img
                  src={`/uploads/${item.image_url}`}
                  onError={(e: any) => {
                    e.target.src = SsqImages.common.icon.noImage();
                    e.target.className = "no-image";
                    e.target.alt = "no_image.svg";
                  }}
                  onClick={() => openNewTabForDocument(item.doc_type, ["QNA_A", "RND_QNA_A"].includes(item.doc_type)
                    ? item.question_id : item.id)}
                  alt={''}/>
              </div>}
            <div className={"txt-wrap"}>
              <div
                className={"desc-wrap " + (item.related_products.length > 0 ? "related-wrap" : "")}>
                  <span
                    onClick={() => openNewTabForDocument(item.doc_type, ["QNA_A", "RND_QNA_A"].includes(item.doc_type)
                      ? item.question_id : item.id)}>{parse(getHighlightedTextFromHtml(item.description))}</span>
              </div>
              {item.related_products.length > 0 && <div className={"txt_bt"}>
                <div className={"related_bt"}>
                  <span>{props.getTranslatedText("I18N_ALL_SEARCH_RELATED_CATEGORY")}</span>
                  <span className={"line"}/>
                  {item.related_products?.split("|").map((category, index) => {
                    return <span key={index}>
                                <span>{category}</span>
                      {item.related_products?.split("|").length > index + 1 &&
                        <span className={"comma"}>,</span>}
                            </span>;
                  })}</div>
              </div>}
              <div className={"tag-txt"}>
                {convertTag && <span>#{parse(convertTag)}</span>}
              </div>
              <div className={"tit-txt"}>
                <span
                  className={"type"}>{[DOC_TYPE.RND_TALK, DOC_TYPE.RND_NOTI, DocType.RND_QNA_Q, DocType.RND_QNA_A].includes(item.doc_type)
                  ? props.getTranslatedText(getDocTypeLangKey(item.doc_type)) + ("(R&D)") :
                  props.getTranslatedText(getDocTypeLangKey(item.doc_type))}</span>
                <span className={"read"}>{props.getTranslatedText("I18N_ALL_SEARCH_CLICK_COUNT")}
                  <b>{item.click_count}</b></span>
              </div>
            </div>
          </div>
        </div>
      </div>;
    })}
    {props.isDisplayNextPageButton && postCount > (20 * (searchPage)) && <ViewmoreArea>
      <div className={"ViewmoreBtn"}>
        <button className={"view-more-button"}
          onClick={async () => {
            setSearchPage(searchPage + 1);
          }}
        >
          {props.getTranslatedText("I18N_ALL_SEARCH_TAB_VIEW_MORE")}</button>
        <div className={"ViewmoreNum"}>
          <span className={"page-count"}>{getPageCount()}</span>
          <span>{getTotalCount()}</span>
        </div>
      </div>
    </ViewmoreArea>}
  </div>;
};
